import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import '../model'
import './model'

// skin
const skin = era.skin('widgets/Payment/ExternalPaymentOpen')

ExternalPaymentOpen.displayName = 'ExternalPaymentOpen'
export function ExternalPaymentOpen(): JSX.Element | null {
  return (
    <ui.RenderSkin
      from={skin}
      name='ExternalPaymentOpen'
      key='ExternalPaymentOpen'
    />
  )
}
